if (EDS.hasOwnProperty('logEvent')) {
  var pageSpeedObj = setTimeout(function () {
    if (typeof BSPageSpeed === 'function') {
      BSPageSpeed = new BSPageSpeed();
      BSPageSpeed.init();
    }
    clearTimeout(pageSpeedObj);
  }, 500);
}

/**
 * Cookie notification After Page Load
 */
var cookieNotification = document.getElementById("cookie-notification"),
cookiePolicyLink = document.getElementById("cookie-policy-link"),
cookieConsentInfo = Cookie.read(stage_env_cookie_prefix + 'ConsentGeoDetail') ? bsLib.JSONParse(Cookie.read(stage_env_cookie_prefix + 'ConsentGeoDetail')) : {};

if (
  cookieNotification &&
  !Cookie.read(stage_env_cookie_prefix + 'UserOptCookie') &&
  cookieConsentInfo.showNewBanner
) {
  cookieNotification.classList.remove("hide");
  
  //settimeout 
  setTimeout(function() {
    if (cookiePolicyLink) {
      cookiePolicyLink.focus();
    }
  }, 0);
}
